/* IVONO: Trustpilot-cijfers site-breed live (Mehmet 25/08: "allemaal dynamisch").
   Eén bron op elke pagina: dezelfde URL en localStorage-cache als de
   reviewcarrousel (iv-testimonials) en de footer-teller (iv-footer), dus op
   een warme cache nul extra requests. Vult elk element met data-iv-tp-live:
     stars  - de sterren (snippet iv-tp-stars): breedte van de groene laag
     score  - de TrustScore, één decimaal in de taal van de pagina (4.5 / 4,5)
     count  - vervangt alleen het getal in de tekst ("500+ reviews" -> "576 reviews")
     label  - Trustpilots eigen woord bij de score (starsString)
     text   - vrije tekst met "Trustpilot" erin (announcement-balk): het
              scorecijfer en het bekende labelwoord worden vervangen, de rest
              van de (vertaalde) tekst blijft staan
   De slanke cachevorm is die van iv-testimonials en iv-footer: tweeling
   bewust gelijk houden (key v5 = mét trustScore en stars). */
(function () {
  var bron = document.querySelector('[data-iv-footer-tp], [data-iv-tp-source]');
  if (!bron) return;
  var src = bron.getAttribute('data-iv-footer-tp') || bron.getAttribute('data-iv-tp-source');
  var doelen = document.querySelectorAll('[data-iv-tp-live]');
  if (!src || !doelen.length) return;
  var key = 'iv-tp-reviews:v5:' + src;
  /* Verversing (Ivo 31/08: "kan de sync wat vlotter?"): 1 uur in plaats van 24.
     Trustpilot zet zelf `cache-control: public,max-age=1800` op dit antwoord
     (gemeten 31/08), dus vaker dan elk half uur levert het endpoint sowieso
     hetzelfde; 1 uur blijft daar netjes boven en is per bezoeker hooguit één
     verzoek van ~8 KB. Deze waarde staat ook in iv-testimonials, iv-footer,
     iv-ivono-at-work en iv-product-rating: ze delen de cache-key, dus laat ze
     gelijk lopen, anders leest de ene een entry als vers die de andere al
     vervangen heeft. */
  var TTL = 60 * 60 * 1000;
  var lang = document.documentElement.lang || 'en';
  var LABELS = /\b(Excellent|Great|Average|Poor|Bad|Uitstekend|Goed|Gemiddeld|Matig|Slecht)\b/;

  // Zelfde formule als de Liquid-startwaarde in snippets/iv-tp-stars.liquid.
  function sterBreedte(stars) {
    var s = Math.max(0, Math.min(5, stars));
    var heel = Math.floor(s);
    if (heel >= 5) return 128;
    return Math.round((heel * 26 + (s - heel) * 24) * 10) / 10;
  }

  function pas(d) {
    var bu = d && d.businessUnit;
    if (!bu) return;
    var score = typeof bu.trustScore === 'number' ? bu.trustScore : null;
    var stars = typeof bu.stars === 'number' ? bu.stars : score;
    var scoreTekst = '';
    if (score !== null) {
      try { scoreTekst = score.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }
      catch (e) { scoreTekst = score.toFixed(1); }
    }
    doelen.forEach(function (el) {
      var soort = el.getAttribute('data-iv-tp-live');
      if (soort === 'stars') {
        if (stars === null) return;
        var vul = el.querySelector('[data-iv-tp-fill]');
        if (vul) vul.setAttribute('width', String(sterBreedte(stars)));
        // Schermlezertekst in de paginataal (QA 26/08: op /nl stond hier Engels).
        var sterSuffix = (document.documentElement.lang || 'en').indexOf('nl') === 0
          ? ' van de 5 sterren' : ' out of 5 stars';
        el.setAttribute('aria-label', (scoreTekst || stars) + sterSuffix);
      } else if (soort === 'score') {
        if (!scoreTekst) return;
        el.textContent = scoreTekst;
      } else if (soort === 'count') {
        if (!bu.total || !/[\d.,+]+/.test(el.textContent)) return;
        el.textContent = el.textContent.replace(/[\d.,+]+/, String(bu.total));
      } else if (soort === 'label') {
        if (!d.starsString) return;
        el.textContent = d.starsString;
      } else if (soort === 'text') {
        var t = el.textContent;
        if (!/trustpilot/i.test(t)) return;
        if (scoreTekst) t = t.replace(/\d[.,]\d/, scoreTekst);
        if (d.starsString) t = t.replace(LABELS, d.starsString);
        el.textContent = t;
      } else {
        return;
      }
      el.setAttribute('data-iv-tp-live-done', '1');
    });
  }

  try {
    var cached = JSON.parse(localStorage.getItem(key) || 'null');
    if (cached && cached.t && Date.now() - cached.t < TTL && cached.d) {
      pas(cached.d);
      return;
    }
  } catch (e) { /* cache onbruikbaar: gewoon fetchen */ }

  fetch(src)
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (d) {
      var bu = d.businessUnit || {};
      var slank = {
        businessUnit: bu.numberOfReviews ? { total: bu.numberOfReviews.total, trustScore: bu.trustScore, stars: bu.stars } : null,
        starsString: d.starsString || '',
        reviews: (d.reviews || []).map(function (r) {
          return {
            stars: r.stars,
            title: r.title,
            text: r.text,
            createdAt: r.createdAt,
            reviewUrl: r.reviewUrl,
            consumer: { displayName: r.consumer && r.consumer.displayName },
            verification: { isVerified: !!(r.verification && r.verification.isVerified) }
          };
        })
      };
      try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: slank })); } catch (e) { /* private mode */ }
      pas(slank);
    })
    .catch(function () { /* de ingestelde cijfers blijven gewoon staan */ });
})();
